import { authToken, reauth } from './liff'

const REAUTH_KEY = 'liff_reauth_ts'

async function parse(res: Response): Promise<any> {
  const text = await res.text()
  const data = text ? JSON.parse(text) : null

  if (res.status === 401 && data?.sessionExpired) {
    // กันลูป: ถ้าเพิ่ง re-login ไป < 20 วิ แล้วยัง 401 → ไม่วนต่อ แสดง error แทน
    const lastReauth = Number(sessionStorage.getItem(REAUTH_KEY) || 0)
    if (Date.now() - lastReauth < 20000) {
      sessionStorage.removeItem(REAUTH_KEY)
      throw new Error('เข้าสู่ระบบไม่สำเร็จ — ปิดหน้านี้ใน LINE แล้วกดเมนูใหม่')
    }
    sessionStorage.setItem(REAUTH_KEY, String(Date.now()))
    reauth()
    throw new Error('เซสชันหมดอายุ กำลังเข้าสู่ระบบใหม่…')
  }

  if (!res.ok) throw new Error(data?.error ?? `เกิดข้อผิดพลาด (HTTP ${res.status})`)
  return data
}

export async function apiGet<T>(path: string): Promise<T> {
  const res = await fetch(`/api${path}`, {
    headers: { Authorization: `Bearer ${authToken()}` },
  })
  return parse(res) as Promise<T>
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`/api${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken()}`,
    },
    body: JSON.stringify(body),
  })
  return parse(res) as Promise<T>
}

export async function apiUpload(file: File): Promise<{ url: string }> {
  const fd = new FormData()
  fd.append('file', file)
  const res = await fetch('/api/upload', {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken()}` },
    body: fd,
  })
  return parse(res) as Promise<{ url: string }>
}
